import type { FaireProductEntity } from "../../entity_types/product";

export const p_yg6ejagk4b: FaireProductEntity = {
  token: "p_yg6ejagk4b",
  type: "product",
  name: "Fluffernutter Tablescape Art Print - New England Food",
  brandToken: "b_2nlyab4cca",
  brandName: "Sarah Wormann Art",
  imageUrl: "https://cdn.faire.com/fastly/d859aac04453502e6dbe209303c1360be7fae1e764e3b0a141a731b61be02a39.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/df749bd4a3d6d5d4585dad5539a85dde601baf77097f03d85ec4fbd4be59a236.jpeg",
    "https://cdn.faire.com/fastly/b0c7c2f5f473b97654f391ac7886d2e1bf8e78e4cbb99231e849e713bc3f222a.jpeg",
    "https://cdn.faire.com/fastly/eca66ce896453fed6949498f2afa4cb7e648ae8ade1521577756b281a4d9ab9e.jpeg",
    "https://cdn.faire.com/fastly/af378c7f8d44de09fad337688deffa3f9841a284de3bed1b80c4e2ea83ad992d.jpeg",
    "https://cdn.faire.com/fastly/258cb81481aa72d6aa78bfb31eb414e076614de1d40c3fb285a56c5341bfa0d5.jpeg"
  ],
  priceDollars: 10,
  description: "Fine art print of a tablescape featuring a fluffernutter sandwich and it's ingredients, originally created with gouache and ink.\n\n\nAll art prints are painted, printed, and packaged by Sarah in her home studio in Boston, MA.\n\n𝐏𝐫𝐢𝐧𝐭 𝐝𝐞𝐭𝐚𝐢𝐥𝐬:\n• Printed on archival paper using pigment inks for crisp details and vibrant colors that will last years and years\n• Hand-signed in pencil\n\n𝐒𝐢𝐳𝐞𝐬:\n• Available sizes: 5”x7”, 8”x10”, 11”x14”\n• Print sizes fit standard frames\n\n𝐏𝐚𝐜𝐤𝐚𝐠𝐢𝐧𝐠 𝐚𝐧𝐝 𝐬𝐡𝐢𝐩𝐩𝐢𝐧𝐠:\n• Each print is packaged in a clear sleeve with cardboard backing, ready to display\n• Orders are shipped in a rigid mailer or cardboard box\n• All prints are unframed",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:53.886Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
